import React from "react";
import { Marker } from "react-map-gl";
import { scaleLinear } from "d3-scale";

import { addThousandSeparator } from "../../util/parseTableData";
import MarkersStyle from "./markers.module.css";

const MarkersCountry = ({
  data,
  mapRef,
  viewport,
  setViewport,
  pulseCountries,
  minCount,
  maxCount,
  setShowPopup,
  setLatFocus,
  setLngFocus,
  setOffsetFocus,
  setTooltip,
}) => {
  const maxRadius = 8;
  const minRadius = 7;
  // const radius = 7;

  const points = React.useMemo(() => {
    return data
      .filter((item) => {
        return !isNaN(parseFloat(item.lat)) && !isNaN(parseFloat(item.lng));
      })
      .map((data) => {
        let recency = pulseCountries.findIndex((element) => {
          return element === data.country;
        });
        if (recency === -1) {
          recency = pulseCountries.length + 1;
        }
        return {
          type: "Feature",
          properties: {
            cluster: false,
            count: data.count,
            country: data.country,
            countryCode: data.countryCode,
            recency: recency,
          },
          geometry: {
            type: "Point",
            coordinates: [parseFloat(data.lng), parseFloat(data.lat)],
          },
        };
      });
  }, [data, pulseCountries]);

  // const bounds = mapRef.current
  //   ? mapRef.current.getMap().getBounds().toArray().flat()
  //   : null;
  
    const markers = points.map(
      ({ properties, geometry }) => {
        let {  count, country,  recency } = properties;
        let radius = Math.min(maxRadius, Math.max(
          minRadius,
          Math.ceil((count / maxCount) * maxRadius)
        ));
        // if (count==0) {
        //   radius = 0;
        // }
        
        let [lng, lat] = geometry.coordinates;

        return !isNaN(lat) && !isNaN(lng) ? (
          <Marker
            key={country}
            offsetTop={-radius}
            offsetLeft={-radius / 2}
            latitude={lat}
            longitude={lng}
          >
            <div
              className={`${MarkersStyle.marker}`}
              style={{
                background: scaleLinear()
                  .clamp(true)
                  .domain([1, pulseCountries.length])
                  .range(["#ff3c19", "#4d302b"])(recency),
                  // .domain([1, pulseCountries.length/6, pulseCountries.length*2/6, pulseCountries.length*4/6,pulseCountries.length*5/6,pulseCountries.length])
                  // .range(["#FF0000","#FFCC00", "#66FF00", "#00FFCC", "#0000FF", "#FF0066"])(recency),
                height: radius,
                width: radius,
              }}
              onMouseEnter={(e) => {
                setLatFocus(lat);
                setLngFocus(lng);
                setOffsetFocus(-(radius / 2));
                setShowPopup(true);
                setTooltip(`${country}: ${addThousandSeparator(
                  count.toString()
                )} sequence${count>1?"s":""}`);
              }}
              onMouseLeave={() => {
                setShowPopup(false);
              }}
            />
          </Marker>
        ) : null;
      }
    );

    return markers;

  
};

export default React.memo(MarkersCountry);
